// extracted by mini-css-extract-plugin
export default {"navigation-mobile__container":"AppNavigationBar_navigation-mobile__container__KpW47"};